import connect from '@clearscore/redux.connect';
import getDevice from '@clearscore/helpers.device';
import { selectors as marketSelectors } from '@clearscore/redux.market';

import lang from './lib/lang';
import FormComponent from './reset-password-form';
import { initiateResetPassword } from '../../lib/redux/actions';

const mapState = (state) => ({
    language: lang({ locale: marketSelectors.getActiveLocale(state) }),
});

const device = getDevice();

const mapDispatch = (dispatch) => ({
    handleReset: (data) =>
        dispatch(
            initiateResetPassword({
                ...data,
                device,
            }),
        ),
});

export default connect(mapState, mapDispatch)(FormComponent);
